import {
    Scene,
    Sound,
    Game,
    GameObjects
} from "phaser";

export class Audio
{
    private scene;
    private game;
    public iconSoundOff: GameObjects.Image;
    public iconSoundOn: GameObjects.Image;
    public ladderSound: Sound.BaseSound;
    public jumpSound: Sound.BaseSound;
    public soundTrack: Sound.BaseSound;
    public victorySound: Sound.BaseSound;

    constructor (scene: Scene, game: Game)
    {
        this.scene = scene;
        this.game = game;
    }

    public loadIcons(): void
    {
        this.scene.load.image('sound_off', 'assets/tilesets/sounds/sound_off.png');
        this.scene.load.image('sound_on', 'assets/tilesets/sounds/sound_on.png');
    }

    public addIcons():void
    {
        this.iconSoundOff = this.scene.add.image(50,130,'sound_off');
        this.iconSoundOn = this.scene.add.image(50,130, 'sound_on').setInteractive();
        this.iconSoundOff.visible =  false;

        // fissi sulla mappa
        this.iconSoundOff.setScrollFactor(0, 0);
        this.iconSoundOn.setScrollFactor(0, 0);

        // davanti agli altri oggetti
        this.iconSoundOn.setDepth(2);
        this.iconSoundOff.setDepth(2);
    }

    public manageAudio(): void
    {
        if (this.game.sound.mute)
        {
            this.game.sound.mute = false;

            this.iconSoundOff.visible= false;
            this.iconSoundOff.disableInteractive();
            this.iconSoundOn.visible= true;
            this.iconSoundOn.setInteractive();
        }
        else
        {
            this.game.sound.mute = true;

            this.iconSoundOn.visible= false;
            this.iconSoundOn.disableInteractive();
            this.iconSoundOff.visible= true;
            this.iconSoundOff.setInteractive();
        }
    }

    public loadAudio(): void
    {
        this.scene.load.audio('coinSound','assets/sounds/Moneta.mp3', {
            instance: 1
        });

        this.scene.load.audio('victorySound','assets/sounds/VITTORIA.mp3', {
            instances: 1
        });

        this.scene.load.audio('jumpSound','assets/sounds/Salto.mp3');
        this.scene.load.audio("ladderSound", "assets/sounds/Scala.mp3", {
            instances: 1
        });

        this.scene.load.audio("music", "assets/sounds/Soundtrack.mp3")
    }

    public addSound(): void
    {
        this.scene.sound.add('coinSound');
        this.jumpSound = this.scene.sound.add("jumpSound");
        this.ladderSound = this.scene.sound.add("ladderSound");
        this.victorySound = this.scene.sound.add('victorySound');
        this.soundTrack = this.scene.sound.add("music", {loop: true, volume: 0.7, delay: 0});
    }

}

